import { CONSTANTS } from "@/constants";
import { gql } from "@apollo/client";
import type { Queries, UserFlowQueriesGetUserFlowByUrlArgs, UserFlowStepType } from "@netfront/api-ekardo-types";
import { useLazyQuery } from "@netfront/apollo-providers";
import { useEffect, useState } from "react";

export const useGetTailoredFeedback = (): { feedbackSteps: UserFlowStepType[], isLoading: boolean } => {
  const [feedbackSteps, setFeedbackSteps] = useState<UserFlowStepType[]>([]);
  
  const { handleQuery: getTailoredFeedbackUserflow, called, isLoading } = useLazyQuery<Pick<Queries, 'userFlow'>, UserFlowQueriesGetUserFlowByUrlArgs>({
    apiName: 'ekardo',
    query: gql`
      query getUserFlowByUrl($projectId: String!, $url: String!) {
        userFlow {
          getUserFlowByUrl(projectId: $projectId, url: $url) {
           userFlowSteps {
              isComplete
              url
              contentGroup {
                id
                iconAsset {
                  presignedUrl
                }
                firstPage {
                  url
                }
                sort
                title
              }

              lastViewedContentPage {
               url
             }

             lastTracking {
               isCompleted
             }
            }
          }
        }
      }
    `,
    onCompleted: ({ userFlow: { getUserFlowByUrl } }) => {
      if(!getUserFlowByUrl) return;
      setFeedbackSteps(
        [...getUserFlowByUrl.userFlowSteps].sort((a, b) => Number(a.contentGroup?.sort) - Number(b.contentGroup?.sort))
      );
    }
  });

  useEffect(() => {
    getTailoredFeedbackUserflow({
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      url: CONSTANTS.USERFLOW.TAILORED_FEEDBACK.URL
    })
  }, []);

  return {
    feedbackSteps,
    isLoading
  }
}